import { AsyncPipe } from '@angular/common';
import { Component, inject } from '@angular/core';
import { RouterLink, RouterLinkActive } from '@angular/router';
import { FaDuotoneIconComponent } from '@fortawesome/angular-fontawesome';
import { Observable } from 'rxjs';
import { UserDetails } from '@bn/api-interfaces';
import { UserDetailsStateService } from '@bn/auth/services';
import { BadgeComponent } from '@bn/web-ui/badge/badge.component';

@Component({
  selector: 'bn-dashboard-support',
  templateUrl: './support.component.html',
  styleUrls: ['./support.component.scss'],
  imports: [RouterLink, RouterLinkActive, FaDuotoneIconComponent, AsyncPipe, BadgeComponent],
})
export class SupportComponent {
  private readonly userDetailsService = inject(UserDetailsStateService);

  public userDetails$: Observable<UserDetails | null>;

  constructor() {
    this.userDetails$ = this.userDetailsService.getUserDetails();
  }
}
